// DocCollector Variable Editor helpers (PAI-1744)
// Bundled by gulp into wwwroot/js/bundle.min.js

(function () {
  const TOKEN_INNER =
    "client_name|organization_name|requested_documents|upload_button|upload_url";
  const TOKEN_REGEX = new RegExp(`\\[(${TOKEN_INNER})\\]`, "g");
  const TOKEN_TEST_REGEX = new RegExp(TOKEN_REGEX.source);

  function isNode(el) {
    return !!el && (el.nodeType === 1 || el.nodeType === 3 || el.nodeType === 9);
  }

  function escapeHtml(text) {
    return (text ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function tokenClass(tokenName) {
    if (tokenName === "upload_button") return "dc-var-chip dc-var-chip--button";
    if (tokenName === "upload_url") return "dc-var-chip dc-var-chip--url";
    return "dc-var-chip dc-var-chip--text";
  }

  function renderWithChips(rawText) {
    TOKEN_REGEX.lastIndex = 0;
    const escaped = escapeHtml(rawText);
    const withBr = escaped.replace(/\r\n|\r|\n/g, "<br>");
    TOKEN_REGEX.lastIndex = 0;
    return withBr.replace(TOKEN_REGEX, (match, tokenName) => {
      const cls = tokenClass(tokenName);
      return `<span class="${cls}" contenteditable="false" data-dc-token="${tokenName}">${match}</span>`;
    });
  }

  function findChipAncestor(el, rootEl) {
    while (el && el !== rootEl) {
      if (
        el.getAttribute &&
        el.getAttribute("contenteditable") === "false" &&
        el.hasAttribute("data-dc-token")
      ) {
        return el;
      }
      el = el.parentElement;
    }
    return null;
  }

  function getCaretOffset(rootEl) {
    if (!isNode(rootEl)) return 0;
    const sel = window.getSelection();
    if (!sel || sel.rangeCount === 0) return 0;
    const range = sel.getRangeAt(0);
    if (!rootEl.contains(range.startContainer)) return 0;

    const preRange = range.cloneRange();
    preRange.selectNodeContents(rootEl);
    preRange.setEnd(range.startContainer, range.startOffset);
    return preRange.toString().length;
  }

  /**
   * Restore caret by flat character offset (matches innerText / getCaretOffset).
   * Never leaves selection inside a token chip (avoids caret trapped in contenteditable=false).
   */
  function setCaretOffset(rootEl, offset) {
    if (!isNode(rootEl)) return;
    const sel = window.getSelection();
    if (!sel) return;

    const walker = document.createTreeWalker(rootEl, NodeFilter.SHOW_TEXT, null);
    let currentNode = walker.nextNode();
    let remaining = offset;

    while (currentNode) {
      const len = currentNode.nodeValue ? currentNode.nodeValue.length : 0;
      if (remaining <= len) {
        const range = document.createRange();
        range.setStart(currentNode, Math.max(0, remaining));
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);
        nudgeCaretOutOfChip(rootEl, sel);
        return;
      }
      remaining -= len;
      currentNode = walker.nextNode();
    }

    const range = document.createRange();
    range.selectNodeContents(rootEl);
    range.collapse(false);
    sel.removeAllRanges();
    sel.addRange(range);
    nudgeCaretOutOfChip(rootEl, sel);
  }

  function nudgeCaretOutOfChip(rootEl, sel) {
    if (!sel || sel.rangeCount === 0) return;
    const r = sel.getRangeAt(0);
    const node = r.startContainer;
    if (node.nodeType !== Node.TEXT_NODE) return;
    const chip = findChipAncestor(node.parentElement, rootEl);
    if (!chip) return;
    const offsetInText = r.startOffset;
    const nr = document.createRange();
    if (offsetInText <= 0) {
      nr.setStartBefore(chip);
    } else {
      nr.setStartAfter(chip);
    }
    nr.collapse(true);
    sel.removeAllRanges();
    sel.addRange(nr);
  }

  function normalizeTextForStorage(text) {
    if (text == null) return "";
    return text.replace(/\u00A0/g, " ");
  }

  function getRawTextFromContentEditable(el) {
    if (!isNode(el)) return "";
    return normalizeTextForStorage(el.innerText || "");
  }

  function setRawTextToContentEditable(el, rawText) {
    if (!isNode(el)) return;
    const caret = getCaretOffset(el);
    el.innerHTML = renderWithChips(rawText || "");
    const maxLen = getRawTextFromContentEditable(el).length;
    setCaretOffset(el, Math.min(caret, maxLen));
  }

  /** True if this text node sits under an existing token chip (already styled). */
  function isInsideTokenChipText(textNode, rootEl) {
    let p = textNode.parentElement;
    while (p && p !== rootEl) {
      if (
        p.getAttribute &&
        p.getAttribute("contenteditable") === "false" &&
        p.hasAttribute("data-dc-token")
      ) {
        return true;
      }
      p = p.parentElement;
    }
    return false;
  }

  /**
   * Wrap plain supported [tokens] in chip spans without replacing the whole editor (caret-friendly).
   * Call after edits so tokens in the middle of the body still get styled.
   */
  function ensureTokenChipsInElement(rootEl) {
    if (!isNode(rootEl)) return;
    const candidates = [];
    const walker = document.createTreeWalker(rootEl, NodeFilter.SHOW_TEXT, null);
    let node;
    while ((node = walker.nextNode())) {
      if (isInsideTokenChipText(node, rootEl)) continue;
      const t = node.nodeValue || "";
      TOKEN_TEST_REGEX.lastIndex = 0;
      if (!t || !TOKEN_TEST_REGEX.test(t)) continue;
      candidates.push(node);
    }
    for (let i = 0; i < candidates.length; i++) {
      const n = candidates[i];
      if (n.isConnected && n.parentNode) {
        replaceTokensInTextNode(n);
      }
    }
  }

  function replaceTokensInTextNode(textNode) {
    if (!textNode.parentNode) return;
    const text = textNode.nodeValue || "";
    const re = new RegExp(TOKEN_REGEX.source, "g");
    const frag = document.createDocumentFragment();
    let lastIndex = 0;
    let m;
    while ((m = re.exec(text)) !== null) {
      if (m.index > lastIndex) {
        frag.appendChild(document.createTextNode(text.slice(lastIndex, m.index)));
      }
      const span = document.createElement("span");
      span.className = tokenClass(m[1]);
      span.setAttribute("contenteditable", "false");
      span.setAttribute("data-dc-token", m[1]);
      span.textContent = m[0];
      frag.appendChild(span);
      lastIndex = m.index + m[0].length;
    }
    if (lastIndex === 0 && frag.childNodes.length === 0) return;
    if (lastIndex < text.length) {
      frag.appendChild(document.createTextNode(text.slice(lastIndex)));
    }
    textNode.parentNode.replaceChild(frag, textNode);
  }

  /** Replace supported [tokens] with chip spans in text nodes only (keeps layout HTML). */
  function decorateVariablesInHtml(htmlString) {
    const doc = new DOMParser().parseFromString(htmlString || "", "text/html");
    const body = doc.body;
    if (!body) return "";

    const walker = doc.createTreeWalker(body, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        let el = node.parentElement;
        while (el) {
          const tag = el.tagName;
          if (tag === "SCRIPT" || tag === "STYLE" || tag === "NOSCRIPT") {
            return NodeFilter.FILTER_REJECT;
          }
          el = el.parentElement;
        }
        return NodeFilter.FILTER_ACCEPT;
      },
    });

    const textNodes = [];
    let cur;
    while ((cur = walker.nextNode())) {
      if (TOKEN_TEST_REGEX.test(cur.nodeValue || "")) {
        textNodes.push(cur);
      }
    }

    for (let i = 0; i < textNodes.length; i++) {
      replaceTokensInTextNode(textNodes[i]);
    }

    return body.innerHTML;
  }

  function setPreviewFromPlain(el, rawText) {
    if (!isNode(el)) return;
    el.innerHTML = renderWithChips(rawText || "");
  }

  function setPreviewFromHtml(el, htmlString) {
    if (!isNode(el)) return;
    el.innerHTML = decorateVariablesInHtml(htmlString || "");
  }

  function insertTokenIntoContentEditable(el, token) {
    if (!isNode(el)) return;
    el.focus();
    const sel = window.getSelection();
    if (!sel || sel.rangeCount === 0) {
      const raw = getRawTextFromContentEditable(el) + token;
      setRawTextToContentEditable(el, raw);
      return;
    }

    const range = sel.getRangeAt(0);
    if (!el.contains(range.startContainer)) {
      const raw = getRawTextFromContentEditable(el) + token;
      setRawTextToContentEditable(el, raw);
      return;
    }

    range.deleteContents();
    const textNode = document.createTextNode(token);
    range.insertNode(textNode);
    range.setStartAfter(textNode);
    range.collapse(true);
    sel.removeAllRanges();
    sel.addRange(range);

    const raw = getRawTextFromContentEditable(el);
    setRawTextToContentEditable(el, raw);
  }

  window.docCollectorVariableEditor = {
    setRawTextToContentEditable,
    getRawTextFromContentEditable,
    insertTokenIntoContentEditable,
    ensureTokenChipsInElement,
    setPreviewFromPlain,
    setPreviewFromHtml,
  };
})();
